class LfMotion extends HTMLElement {
  connectedCallback() {
    this.disconnect();
    this.controller = new AbortController();
    this.seen = new WeakSet();
    this.pendingRoots = new Set();
    this.selector = '.lf-home-heading, .lf-home-projects article, .lf-home-services > a, .lf-home-method li, .blog-post-card, product-card, .lf-footer-invite';
    this.animations = new Set();
    this.preference = matchMedia('(prefers-reduced-motion: reduce)');
    this.preference.addEventListener('change', () => this.configure(), { signal: this.controller.signal });
    this.configure();
  }

  configure() {
    this.observer?.disconnect();
    this.mutations?.disconnect();
    for (const animation of this.animations) animation.cancel();
    this.animations.clear();
    if (this.preference.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode || !Element.prototype.animate) return;
    this.observer = new IntersectionObserver(entries => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        this.observer.unobserve(entry.target);
        if (this.preference.matches) continue;
        const animation = entry.target.animate([
          { opacity: 0.25, translate: '0 18px' },
          { opacity: 1, translate: '0 0' }
        ], { duration: 650, easing: 'cubic-bezier(.2,.7,.2,1)' });
        this.animations.add(animation);
        animation.finished.then(() => this.animations.delete(animation)).catch(() => this.animations.delete(animation));
      }
    }, { threshold: 0.08 });
    this.scan();
    const main = document.getElementById('MainContent');
    if (main) {
      this.mutations = new MutationObserver(records => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeType === 1 && (node.matches(this.selector) || node.querySelector(this.selector))) this.pendingRoots.add(node);
          }
        }
        if (!this.pendingRoots.size || this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          for (const root of this.pendingRoots) {
            if (root.isConnected) this.scan(root);
          }
          this.pendingRoots.clear();
        });
      });
      this.mutations.observe(main, { childList: true, subtree: true });
    }
  }

  scan(root = document) {
    if (this.preference.matches) return;
    const elements = [...(root.matches?.(this.selector) ? [root] : []), ...root.querySelectorAll(this.selector)];
    for (const element of elements) {
      if (!element.closest('#MainContent') && !element.matches('.lf-footer-invite')) continue;
      if (this.seen.has(element)) continue;
      this.seen.add(element);
      if (element.getBoundingClientRect().top < innerHeight * 0.9) continue;
      this.observer.observe(element);
    }
  }

  disconnect() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.mutations?.disconnect();
    if (this.frame) cancelAnimationFrame(this.frame);
    this.frame = null;
    this.pendingRoots?.clear();
    for (const animation of this.animations || []) animation.cancel();
  }

  disconnectedCallback() {
    this.disconnect();
  }
}
if (!customElements.get('lf-motion')) customElements.define('lf-motion', LfMotion);
